import React from 'react';
import PropTypes from 'prop-types';
import { Button, Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import { ensureKeyed } from 'utils';

import { modals } from '../ducks';

class ModalComponent extends React.Component {
  static propTypes = {
    buttons: PropTypes.array,
    id: PropTypes.string,
    className: PropTypes.string,
    bodyClassName: PropTypes.string,
    onClose: PropTypes.func,
    title: PropTypes.string,
    closeText: PropTypes.string
  };

  static defaultProps = {
    buttons: [],
    title: '',
    onClose: () => false,
    className: '',
    bodyClassName: '',
    id: '',
    closeText: 'Close'
  };

  static mapDispatchToProps = (dispatch, props) => ({
    onClose: props.onClose || (() => dispatch(modals.actions.hide()))
  });

  componentDidMount() {
    // Bootstrap sets overflow to 'hidden' on body when a modal is visible
    // ...we want to undo that so that a modal that exceeds the height of the page can be scrolled
    document.body.style.overflowY = 'visible';
  }

  render() {
    const {
      buttons,
      children,
      id,
      className,
      bodyClassName,
      onClose,
      title,
      closeText
    } = this.props;

    return (
      <Modal
        id={id}
        className={className}
        animation={false}
        show
        backdrop='static'
        keyboard={false}
      >
        <Modal.Header>
          <h1 className='modal-title' style={{ display: 'inline-block' }}>{title}</h1>
          <button type='button' className='btn-close' aria-label='Close' onClick={onClose} />
        </Modal.Header>
        {/* Set overflow to 'visible' so that drop-downs pop out of modal */}
        <Modal.Body className={bodyClassName} style={bodyClassName ? {} : { overflow: 'visible' }}>
          {children}
        </Modal.Body>
        <Modal.Footer>
          <Button variant='light' onClick={onClose}>{closeText}</Button>
          {buttons.filter(button => button).map(ensureKeyed())}
        </Modal.Footer>
      </Modal>
    );
  }
}

export default connect(null, ModalComponent.mapDispatchToProps)(ModalComponent);
